import * as _ from "lodash";
import {WARNINGS_TO_FIELD, WARNINGS_TO_HOOKS} from "./submit-warnings-to-fields";
import {apiInterpolate} from "./error/interpolate-warnings-filter";

export class SubmitCalls {
  static FORM_CONTROL_VALIDATIONS = [];

  static findWarningControl(form: any, fieldRef: string, resourceName?: string): any {
    const candidates = [
      fieldRef,
      resourceName ? resourceName + '.' + fieldRef : null,
      'resource.model.' + fieldRef
    ].filter(Boolean) as string[];

    const ngForm = form?.ngForm || form;
    const controls = ngForm?.controls;

    for (const name of candidates) {
      const fromForm = _.get(form, name);
      if (fromForm) {
        return fromForm;
      }
      if (controls?.[name]) {
        return controls[name];
      }
    }

    if (controls) {
      const match = Object.keys(controls).find((name) => {
        return name === fieldRef || _.endsWith(name, '.' + fieldRef);
      });
      if (match) {
        return controls[match];
      }
    }
    return null;
  }

  static updateFormWarnings(form, model, isPureMarketplacePlatform?: boolean) {
    const doTheUpdate = () => {
      // Compute before control updates. Defer the binding flip: emitEvent nested CD
      // and sibling list HTTP settle can overlap this timer (NG0100 on edit pages).
      const nextHasWarnings = !!_.find(model.validationWarnings, function (vw) {
        return vw.preventsAdServing;
      });
      queueMicrotask(() => {
        setTimeout(() => {
          form.hasValidationWarnings = nextHasWarnings;
        }, 0);
      });
      _.forEach(this.FORM_CONTROL_VALIDATIONS, function (val) {
        delete val.control.validation;
        if (_.isFunction(val.control.updateValueAndValidity)) {
          val.control.updateValueAndValidity({emitEvent: true});
        }
      });
      this.FORM_CONTROL_VALIDATIONS = [];
      _.forEach(_.filter(WARNINGS_TO_HOOKS, function (wf) {
        return wf.idHook;
      }), function (wf) {
        const el = document.getElementById(wf.idHook);
        if (el) {
          el.innerHTML = "";
          el.style.display = 'none';
        }
      });
      _.forEach(model.validationWarnings || [], (warning) => {
        const idHook = _.get(WARNINGS_TO_HOOKS, [warning.code, 'idHook']);
        if (idHook) {
          const el = document.getElementById(idHook);
          if (el) {
            el.innerHTML = warning.text;
            el.style.display = '';
          }
          return;
        }
        const fieldRefs = _.get(WARNINGS_TO_FIELD, [warning.code, 'field']);
        if (!fieldRefs) {
          return;
        }
        let control;
        _.find(fieldRefs, (fieldRef) => {
          control = this.findWarningControl(form, fieldRef, model.resourceName);
          return control;
        });
        if (control) {
          control.validation = apiInterpolate(warning, isPureMarketplacePlatform);
          if (_.isFunction(control.updateValueAndValidity)) {
            control.updateValueAndValidity({emitEvent: true});
          }
          this.FORM_CONTROL_VALIDATIONS.push({
            control: control
          });
        }
      });
    };
    window.setTimeout(doTheUpdate, 150);
  }
}
